import { render } from "./DropdownList.vue?vue&type=template&id=5b6b627c&scoped=true"
import script from "./DropdownList.vue?vue&type=script&lang=js"
export * from "./DropdownList.vue?vue&type=script&lang=js"

import "./DropdownList.vue?vue&type=style&index=0&id=5b6b627c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6b627c"]])

export default __exports__